export function is_super_admin_role(role) {
  const normalized_role = String(role || '')
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return normalized_role.includes('super admin');
}

export function is_super_admin() {
  return is_super_admin_role(
    sessionStorage.getItem('current_role') || sessionStorage.getItem('user_role')
  );
}

function parse_url(raw_url) {
  if (typeof raw_url !== 'string' || !raw_url.trim()) return null;
  try {
    return new URL(raw_url.trim());
  } catch (_error) {
    return null;
  }
}

export function safe_redirect_url(raw_url) {
  const url = parse_url(raw_url);
  if (!url || url.username || url.password) return '';
  const is_https = url.protocol === 'https:' && url.hostname;
  const is_localhost = url.protocol === 'http:'
    && ['localhost', '127.0.0.1', '::1'].includes(url.hostname.toLowerCase());
  return is_https || is_localhost ? url.toString() : '';
}
